import React from 'react';
import { Link } from 'react-router-dom';

// Mention d'information affichée juste avant le bouton d'envoi des
// formulaires de réservation et de contact.
// Contenu à faire valider par un juriste.
const PrivacyNotice = () => (
  <p className="text-xs text-[#4A4458] leading-relaxed">
    Les informations saisies servent uniquement à traiter votre demande et à vous recontacter. Elles sont
    conservées [À COMPLÉTER : durée]. Vous pouvez y accéder, les corriger ou les faire supprimer en écrivant à
    [À COMPLÉTER : adresse]. En savoir plus :{' '}
    <Link to="/politique-de-confidentialite" className="text-[#21167D] underline underline-offset-2">
      politique de confidentialité
    </Link>
  </p>
);

export default PrivacyNotice;
